module.exports = __webpack_public_path__ + "static/pdf/導入ご検討の施設の皆様へ.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/導入ご検討の施設の皆様へ.pdf
// module id = Fbdt
// module chunks = 1